exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-card[data-v-49bf478c] {\n  height: 36px;\n  width: 36px;\n}\n.close-card svg[data-v-49bf478c] {\n  width: 22px;\n  height: 22px;\n  color: #6f707b;\n}\n", ""]);

// exports
